import React from 'react';
import Title from "../../containers/title/title";
import Gallery from "../../containers/gallery/gallery";
import Form from './form/form';
import classes from "./events.module.css"

const Events = (props) => {
    return (
        <div className={classes.Container}>
            <div className={classes.HeroImage} />
            <div className={classes.Description}>
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Have an event in mind? Share your vision with us, and we'll plan and organize it to perfection!" 
                    : "هل لديك فعالية في ذهنك؟ شاركنا رؤيتك وسنقوم بتخطيطها وتنظيمها بشكل مثالي!"}
            </div>
            <Title 
                title={parseInt(localStorage.getItem('language')) === 1 ? "CREATE AN EVENT" : "إنشاء فعالية"} 
            />
            <p className={classes.FormDescription}>
                {parseInt(localStorage.getItem('language')) === 1 
                    ? "Fill up the form and submit it and we will contact you shortly" 
                    : "املأ النموذج وأرسله وسنتواصل معك قريباً"}
            </p>
            {props.eventTypes?.available_slots ? (
                <Form
                    isAuthenticated={props.isAuthenticated}
                    setShowLoginForm={props.setShowLoginForm}
                    activityTypes={props.eventTypes?.activities}
                    availableSlots={props.eventTypes?.available_slots}
                />
            ) : (
                <p>Loading available slots...</p>
            )}
            {props.imageList?.length > 0 && <>
                <Title 
                    title={parseInt(localStorage.getItem('language')) === 1 ? "GALLERY" : "معرض الصور"} 
                />
                <Gallery images={props.imageList} />
            </>}
        </div>
    )
}
export default Events;